export const contactCardsData = [
  {
    title: "Email Us",
    description:
      "Please feel free to drop us a line. We will respond as soon as possible.",
    action: "Leave a message",
    href: "mailto:info@cwdplatforms.com",
    icon: "ion:mail-open-outline",
    titleSize: "text-24",
  },
  {
    title: "Careers",
    description:
      "Join our team. Explore exciting opportunities and grow your career with us.",
    action: "Send an application",
    href: "/careers",
    icon: "ion:briefcase-outline",
    titleSize: "text-24",
  },
];

export const locationsData = [
  {
    city: "Navi Mumbai",
    type: "Development Center",
    address:
      "14th floor, Unit 1406 - 1409, Rupa Solitaire, Millenium Business Park, Mahape, Navi Mumbai - 400710",
  },
  {
    city: "Mysore",
    type: "Manufacturing Facility",
    address: "Plot No 242-B, Thandya 2nd Phase, Chikkaiahnachatra Industrial Area, Thandavapura Village, Hobli, Nanjangud Taluk, Mysuru District, Karnataka – 571302",
  },
];
